import { useState, useEffect } from "react";
import { Box, Container, Grid } from "@mui/material";
import { cardUtility } from "./CardUtil";
import { useNavigate } from "react-router-dom";
import CardSearch from "./components/CardSearch";
import { getGameSystems } from "../../components/api/APIUtilities";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import GameSystemPicker from "../../components/utilities/gamesystempickers/GameSystemPicker";
import { postNotification } from "../../components/utilities/Notifications";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { getData } from "../../components/utilities/UtilityFunctions";
const SINGLE_GAMETYPE = getEnvironmentVariable("SINGLE_GAMETYPE");
const SINGLE_GAME_SYSTEM = getEnvironmentVariable("SINGLE_GAME_SYSTEM");

export default function Cards() {
  const navigate = useNavigate();
  const cardUtil = cardUtility();

  const [loading, setLoading] = useState(
    SINGLE_GAMETYPE !== undefined ? true : false
  );
  const [ready, setReady] = useState(
    SINGLE_GAMETYPE !== undefined ? true : false
  );
  const [gameSystems, setGameSystems] = useState(null);
  const [gameSystem, setGameSystem] = useState(null);

  useEffect(() => {
    const go = async () => {
      if (SINGLE_GAMETYPE === undefined) {
        var apiGameSystems = await getGameSystems({
          supportsDeckBuilder: true,
        });
        if (!apiGameSystems?.length) {
          postNotification(
            `No ${getEnvironmentVariable(
              "LABEL_GAMESYSTEM"
            )}s setup with a card database`
          );
          navigate("/");
          return;
        }
        setGameSystems(apiGameSystems);
      } else {
        const apiGameSystem = await getData(
          `/gamesystems/${SINGLE_GAME_SYSTEM}`
        );
        setGameSystem(apiGameSystem);
      }
      setLoading(false);
    };

    go();

    // eslint-disable-next-line
  }, []);
  return (
    <Box sx={{ width: "100%" }}>
      <Container
        sx={{
          pt: 2,
          pb: 2,
        }}
        maxWidth="lg"
      >
        {!ready && gameSystems && (
          <Grid
            item
            xs={12}
            sx={{
              p: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              borderRadius: 1,
              boxShadow: 1,
              backgroundColor: "background.secondary",
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <GameSystemPicker
                  name="gameType"
                  value={gameSystem?.code || ""}
                  handleChange={(e) => {
                    if (e.target.value) {
                      gameSystems.forEach((gs) => {
                        if (gs.code === e.target.value) {
                          setGameSystem(gs);
                          setReady(true);
                          return true;
                        }
                      });
                    }
                  }}
                  gameSystems={gameSystems}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
        {ready && (
          <CardSearch
            heading="Card Library"
            gameSystem={gameSystem}
            cardUtil={cardUtil}
          />
        )}
      </Container>
      {loading && <ModalLoadingFull />}
    </Box>
  );
}
